<template lang="pug">
v-textarea(
  v-validate="validates.value"
  v-model="localValue"
  :solo="solo"
  :error-messages="errors.collect('memo')"
  :counter="validates.value.max"
  :label="$t('attributes.answer.memo')"
  :disabled="disabled"
  outline
  name="memo"
  key="memo")
</template>
<script>
export default {
  name: "AnswerMemoField",
  props: {
    value: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    solo: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    validates: {
      value: {
        max: 500,
      },
    },
  }),
  computed: {
    localValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
}
</script>
